import { render, staticRenderFns } from "./pickQuestion.vue?vue&type=template&id=73c4ffa1&scoped=true&"
import script from "./pickQuestion.vue?vue&type=script&lang=js&"
export * from "./pickQuestion.vue?vue&type=script&lang=js&"
import style0 from "./pickQuestion.vue?vue&type=style&index=0&id=73c4ffa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c4ffa1",
  null
  
)

export default component.exports